import textBalancer from 'text-balancer';

export default class RotateStatements {
  constructor(options) {
    const defaults = {
      startDelay: 0,
      statements: null,
      containerElement: null,
      textElement: null,
      animateWidth: true,
    };
    this.currentStatement = 0;
    this.settings = $.extend({}, defaults, options);
    this.statement_count = this.settings.statements.length;
    this.autoRotateStatements();
  }

  autoRotateStatements = () => {
    clearInterval(this.interval);
    this.interval = setInterval(this.showStatement, this.settings.speed);
  };

  showStatement = () => {
    this.currentStatement += 1;
    if (this.currentStatement > this.statement_count - 1) {
      this.currentStatement = 0;
    }
    $(this.settings.containerElement).addClass('animating');

    setTimeout(() => {
      $(this.settings.textElement).text(
        this.settings.statements[this.currentStatement]
      );
      textBalancer.balanceText();
      if (this.settings.animateWidth) {
        $(this.settings.containerElement).width(
          $(this.settings.textElement).width()
        );
      }
    }, this.settings.speed / 8);

    setTimeout(() => {
      $(this.settings.containerElement).removeClass('animating');
    }, this.settings.speed / 4);
  };

  pause = () => {
    window.clearInterval(this.interval);
  };
}
